/**
 * Trim whitespace from string items in given array and remove empty items afterwards
 */
export function trimReduce(arr: string[]): any {
  return (arr || []).reduce<string[]>((filtered, item) => {
    item = item && typeof item === 'string' ? item.replace(/^\s+|\s+$/g, '') : '';
    if (item.length) {
      filtered.push(item);
    }
    return filtered;
  }, []);
}
